export function resolveMediaUrl(url) {
  if (!url) return '';
  if (url.startsWith('http') || url.startsWith('data:')) return url;
  if (url.startsWith('/')) return `${window.location.origin}${url}`;
  return url;
}

export function getProductImage(product) {
  return product?.thumbnail_url || product?.images?.[0] || '';
}

export function getProductImageUrl(product) {
  return resolveMediaUrl(getProductImage(product));
}

export function getProductImages(product) {
  const images = [...(product?.images || [])].filter(Boolean);
  const thumb = product?.thumbnail_url;
  if (thumb && !images.includes(thumb)) {
    return [thumb, ...images];
  }
  return images.length ? images : (thumb ? [thumb] : []);
}
